"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeliverySuggestions = useDeliverySuggestions;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _logger = require("../../logger");
var _models = require("../../models");
var _useDeliveryFilters = require("../DeliveryOptions/useDeliveryFilters");
const getLastAddressFromLoadedData = (prioritizedAddressId, result) => result.find(item => item.addressId === prioritizedAddressId);

/** Helper hook for delivery suggestions section. Used also for flat selection UI. */
function useDeliverySuggestions({
  activeAddressFilter,
  activeFilter,
  addressFilters,
  filters,
  isDisplayingAddresses,
  isFlatSelection,
  isRefreshPending,
  isSelectedDeliveryLoading,
  onDeliveryItemActivation,
  selectedItem,
  selectedItemHome,
  setActiveAddressFilter,
  setActiveFilter,
  setIsDisplayingAddresses,
  setIsSuggestionAvailable,
  setSelectedItemHome
}) {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const [currentPage, setCurrentPage] = (0, _react.useState)(0);
  const [isFirstLoad, setIsFirstLoad] = (0, _react.useState)(true);
  const [isHistoryEmpty, setIsHistoryEmpty] = (0, _react.useState)(false);
  const {
    lastAddress,
    prioritizedAddressId,
    setIsLastAddressValid
  } = (0, _contexts.useAddressForm)();
  function showMoreSuggestions() {
    setCurrentPage(currentPage + 1);
  }
  const {
    deliveryFilterProps,
    filterValue,
    isActiveFilter
  } = (0, _useDeliveryFilters.useDeliveryFilters)({
    activeAddressFilter,
    activeFilter,
    addressFilters,
    filters,
    isDisplayingAddresses,
    setActiveAddressFilter,
    setActiveFilter,
    setCurrentSuggestionsPage: setCurrentPage
  });
  const onSuggestionsLoadSuccess = (0, _react.useCallback)((result, pageIndex) => {
    const hasResults = result.length > 0;
    if (prioritizedAddressId !== undefined && hasResults) {
      const localLastAddress = getLastAddressFromLoadedData(prioritizedAddressId, result);
      if (localLastAddress) {
        lastAddress.current = localLastAddress;
        const addressValidity = Boolean(localLastAddress.isAllowed);
        (0, _logger.logDebug)('Last prioritized address validity:', addressValidity, localLastAddress);
        setIsLastAddressValid(addressValidity);
      }
    }
    setIsSuggestionAvailable(hasResults);
    if (pageIndex === 0 && !isDisplayingAddresses && isFirstLoad && result.slice(0, 2).every(item => !item.isAllowed)) {
      setIsDisplayingAddresses(true);
    }
    /*
    Flat selection UI - select 1st valid address when main switch is on home addresses & selectedItem is not set.
    The onSuggestionsLoadSuccess callback is called only when loading suggestions, means for flat selection UI,
    the home delivery section is currently visible. So there is probably no need to also check main delivery method here.
    Not having a selected home delivery item means the user had selected pickup point before, or there was
    no delivery selection at all.
    */
    if (isFlatSelection && !selectedItemHome && hasResults && pageIndex === 0) {
      const firstValidItem = result.find(item => item.isAllowed);
      if (firstValidItem) {
        (0, _logger.logDebug)('Selecting first valid home delivery item', firstValidItem);
        setSelectedItemHome(firstValidItem);
        onDeliveryItemActivation(firstValidItem);
      }
    }
    setIsFirstLoad(false);
    setIsHistoryEmpty(!isDisplayingAddresses && !hasResults);
  }, [isDisplayingAddresses, isFirstLoad, isFlatSelection, lastAddress, onDeliveryItemActivation, prioritizedAddressId, selectedItemHome, setIsDisplayingAddresses, setIsLastAddressValid, setIsSuggestionAvailable, setSelectedItemHome]);
  const suggestionsProps = {
    activeFilter: filterValue,
    currentPage,
    isDisplayingAddresses,
    isFlatSelection,
    isRefreshPending,
    isSelectedDeliveryLoading,
    prioritizedAddressId,
    onDeliveryItemActivation,
    onSuggestionsLoadSuccess,
    selectedItem,
    selectedItemHome,
    setIsDisplayingAddresses,
    showMoreSuggestions,
    ...getTestIdProps(isDisplayingAddresses ? _models.TestId.AddressSuggestions : _models.TestId.HistorySuggestions)
  };
  return {
    deliveryFilterProps,
    filterValue,
    isActiveFilter,
    isHistoryEmpty,
    suggestionsProps
  };
}